import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tun-list-icon',
  templateUrl: './list-icon.component.html',
  styleUrls: ['./list-icon.component.scss']
})
export class ListIconComponent implements OnInit {

  @Input() color: string;

  constructor() { }

  ngOnInit() {
  }

}
